import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ICreateDun } from '../../interfaces/StockKeepingUnitDun/StockKeepingUnitDun'

export const getProductList = (filters?: Filter[], page = 0, pageSize = 5) => {
  const url = new URL(`${ApiConfig.StockKeepingUnitApi}`)
  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (element.key === 'externalStatusId') {
        url.searchParams.set('statusId', element.value)
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.get(url.toString())
}

export const postExternalStorage = (skid: number, externalStorage: boolean) => {
  const url = new URL(
    `${ApiConfig.StockKeepingUnitApi}/ExternalStorage/${skid}`
  )
  return axios.patch(url.toString(), JSON.stringify(externalStorage), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// Metodos para DUN //

// obtiene las unidades de medida
export const getTypePackage = () => {
  const url = new URL(`${ApiConfig.TypePackageApi}`)
  return axios.get(url.toString())
}

export const getListDun = (sku: string) => {
  const url = new URL(
    `${ApiConfig.StockKeepingUnitDun}?Sku=${sku}&pageSize=100`
  )
  return axios.get(url.toString())
}

export const getListDunPage = (sku: string, page = 0, pageSize = 10) => {
  const url = new URL(
    `${ApiConfig.StockKeepingUnitDun}?Sku=${sku}&pageIndex=${page}&pageSize=${pageSize}`
  )
  return axios.get(url.toString())
}

export const deleteStockkeepingUnitDun = (stockKeepingUnitDunId: number) => {
  const url = new URL(
    `${ApiConfig.StockKeepingUnitDun}/${stockKeepingUnitDunId}`
  )
  return axios.delete(url.toString())
}

// se actualiza de manera unitaria ahora.
export const putStockKeepingUnitDun = (listDun: ICreateDun[]) => {
  const url = new URL(`${ApiConfig.StockKeepingUnitDun}`)
  return axios.put(url.toString(), JSON.stringify(listDun[0]), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const postStockKeepingUnitDun = (listDun: ICreateDun[]) => {
  const url = new URL(`${ApiConfig.StockKeepingUnitDun}`)
  return axios.post(url.toString(), JSON.stringify(listDun[0]), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const postExportSkuMasive = (filters?: Filter[]) => {
  const url = new URL(`${ApiConfig.ProcessApi}/ExportSkuMasive`)
  const jsonObject = filters?.reduce((acc, filter) => {
    acc[filter.key] = filter.value
    return acc
  }, {} as Record<string, any>)
  return axios.post(url.toString(), jsonObject)
}


export const getVasRuleLogs = (skuId: number) => {
  const url = new URL(`${ApiConfig.StockKeepingUnitAdminApi}/${skuId}/blog`)
  return axios.get(url.toString())
}